import { useSnackbar } from 'notistack';
import { useState, useContext } from 'react';
import { Button } from 'src/@/components/ui/button';
import { Textarea } from 'src/@/components/ui/textarea';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import v2_actionFinalizarMultiplosChats from 'src/actions/v2/chats/v2_actionFinalizarMultiplosChats';
import { RowInput } from 'src/components/forms/RowInput';
import Iconify from 'src/components/Iconify';
import { deleteAllCacheFiles } from 'src/helpers/cache.helper';
import { SettingsContext } from 'src/contexts/SettingsContext';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from 'src/@/components/ui/select';
import { getPrefsAlertas, setPrefsAlertas } from 'src/services/notifications';

const REPETICAO_OPCOES = [
    { value: 'sessao', label: 'Uma vez por sessão', ajuda: 'Aparecem ao entrar; atualizar a página não repete. Voltam no próximo login, enquanto não forem lidos.' },
    { value: 'unica', label: 'Só uma vez', ajuda: 'Cada aviso aparece uma única vez neste computador. Depois fica apenas no sino.' },
    { value: 'sempre', label: 'Sempre, até eu ler', ajuda: 'Reaparecem a cada entrada no painel enquanto o aviso não for lido.' },
];

const JANELA_OPCOES = [
    { value: 3, label: 'Últimos 3 dias' },
    { value: 7, label: 'Últimos 7 dias' },
    { value: 15, label: 'Últimos 15 dias' },
    { value: 30, label: 'Últimos 30 dias' },
];


export default function Preferencias({
    checkedSomNotificacao,
    changeSomNotificacao,
    mensagemIntervalo,
    changeMensagemIntervalo,
    isModificado,
    changeIsModificado,
    onSubmit,
    user,
    cliente,
    config,
    changeConfig
}) {

    const { enqueueSnackbar } = useSnackbar();
    const [loadingLimparChats, setLoadingLimparChats] = useState(false);
    const { themeMode, onChangeMode } = useContext(SettingsContext);

    const [layoutMode, setLayoutMode] = useState(() => {
        return localStorage.getItem('layoutMode') || 'sidebar';
    });

    // Avisos pendentes ao entrar: preferencia pessoal, gravada na hora como o
    // som e o tema — sem depender do botao Salvar.
    const [prefsAlertas, setPrefsAlertasState] = useState(getPrefsAlertas);

    const alterarAlertas = (parcial) => setPrefsAlertasState(setPrefsAlertas(parcial));

    const ajudaRepeticao = REPETICAO_OPCOES.find(o => o.value === prefsAlertas.repeticao)?.ajuda;

    const handleLayoutChange = (mode) => {
        setLayoutMode(mode);
        localStorage.setItem('layoutMode', mode);
        window.dispatchEvent(new Event('layoutModeChange'));
    };

    const handleThemeChange = (mode) => {
        onChangeMode({ target: { value: mode } });
    };

    async function limparChats() {
        try {
            let data = {
                usuarioId: user.id,
                status: 'Geral',
                clienteId: cliente._id,
            }
            setLoadingLimparChats(true)
            const result = await v2_actionFinalizarMultiplosChats(data);
            if (result.data.error) {
                setLoadingLimparChats(false)
                enqueueSnackbar('Erro ao finalizar chats', { variant: 'error' });
            }
            setLoadingLimparChats(false)
            enqueueSnackbar('Chats foram colcoados em fila para finalização. Essa ação pode demorar alguns minutos', { variant: 'success', autoHideDuration: 10000 });
        } catch (error) {
            setLoadingLimparChats(false)
            console.log(error);
            enqueueSnackbar('Erro ao limpar chats', { variant: 'error' });
        }
    }

    return (
        <div className="max-w-2xl space-y-6">

            {/* Notificacoes */}
            <div>
                <h4 className="text-sm font-semibold text-gray-900 dark:text-[#D1D2D3] mb-3">Notificações</h4>
                <label className="inline-flex items-center gap-3 cursor-pointer group">
                    <div className="relative">
                        <input
                            type="checkbox"
                            checked={checkedSomNotificacao}
                            onChange={changeSomNotificacao}
                            className="sr-only peer"
                        />
                        <div className="w-9 h-5 bg-gray-200 dark:bg-[#383838] rounded-full peer-checked:bg-[#7C3AED] transition-colors" />
                        <div className="absolute left-0.5 top-0.5 w-4 h-4 bg-white rounded-full shadow-sm transition-transform peer-checked:translate-x-4" />
                    </div>
                    <span className="text-xs text-gray-600 dark:text-[#ABABAD]">Som notificação</span>
                </label>
                <p className="text-[11px] text-gray-400 dark:text-[#ABABAD]/70 mt-1.5">
                    Vale para todos os avisos do painel: conversas, chamados e tarefas.
                </p>

                {/* Avisos que chegaram enquanto o usuario estava fora */}
                <div className="mt-4 p-3.5 rounded-xl border border-gray-200 dark:border-[#383838]">
                    <label className="flex items-start justify-between gap-4 cursor-pointer group">
                        <span>
                            <span className="flex items-center gap-1.5 text-sm font-medium text-gray-900 dark:text-[#D1D2D3]">
                                <Iconify icon="mdi:clipboard-check-outline" width={15} className="text-[#7C3AED] shrink-0" />
                                Tarefas: avisos pendentes ao entrar
                            </span>
                            <span className="block text-xs text-gray-500 dark:text-[#ABABAD] mt-0.5">
                                Mostra, num canto da tela, os avisos de <strong className="font-medium">tarefas</strong> que chegaram enquanto você estava fora — atribuições, comentários e prazos. Não se aplica a conversas nem chamados.
                            </span>
                        </span>
                        <span className="relative shrink-0 mt-0.5">
                            <input
                                type="checkbox"
                                checked={prefsAlertas.ativo}
                                onChange={e => alterarAlertas({ ativo: e.target.checked })}
                                className="sr-only peer"
                            />
                            <div className="w-9 h-5 bg-gray-200 dark:bg-[#383838] rounded-full peer-checked:bg-[#7C3AED] transition-colors" />
                            <div className="absolute left-0.5 top-0.5 w-4 h-4 bg-white rounded-full shadow-sm transition-transform peer-checked:translate-x-4" />
                        </span>
                    </label>

                    {prefsAlertas.ativo && (
                        <div className="mt-4 space-y-3">
                            <div>
                                <label className="text-[11px] font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider mb-1.5 block">
                                    Com que frequência repetir
                                </label>
                                <Select
                                    value={prefsAlertas.repeticao}
                                    onValueChange={v => alterarAlertas({ repeticao: v })}
                                >
                                    <SelectTrigger className="h-9 text-xs rounded-lg border-gray-200 dark:border-[#383838] dark:bg-[#1A1D21] dark:text-[#D1D2D3]">
                                        <SelectValue />
                                    </SelectTrigger>
                                    <SelectContent className="z-[10000]">
                                        {REPETICAO_OPCOES.map(o => (
                                            <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                                <p className="mt-1.5 text-xs text-gray-500 dark:text-[#ABABAD] leading-relaxed">{ajudaRepeticao}</p>
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                <div>
                                    <label className="text-[11px] font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider mb-1.5 block">
                                        Quantos por vez
                                    </label>
                                    <Select
                                        value={String(prefsAlertas.maxVisiveis)}
                                        onValueChange={v => alterarAlertas({ maxVisiveis: Number(v) })}
                                    >
                                        <SelectTrigger className="h-9 text-xs rounded-lg border-gray-200 dark:border-[#383838] dark:bg-[#1A1D21] dark:text-[#D1D2D3]">
                                            <SelectValue />
                                        </SelectTrigger>
                                        <SelectContent className="z-[10000]">
                                            {[2, 3, 4, 5].map(n => (
                                                <SelectItem key={n} value={String(n)}>{n} avisos</SelectItem>
                                            ))}
                                        </SelectContent>
                                    </Select>
                                </div>

                                <div>
                                    <label className="text-[11px] font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider mb-1.5 block">
                                        Considerar tarefas dos
                                    </label>
                                    <Select
                                        value={String(prefsAlertas.janelaDias)}
                                        onValueChange={v => alterarAlertas({ janelaDias: Number(v) })}
                                    >
                                        <SelectTrigger className="h-9 text-xs rounded-lg border-gray-200 dark:border-[#383838] dark:bg-[#1A1D21] dark:text-[#D1D2D3]">
                                            <SelectValue />
                                        </SelectTrigger>
                                        <SelectContent className="z-[10000]">
                                            {JANELA_OPCOES.map(o => (
                                                <SelectItem key={o.value} value={String(o.value)}>{o.label}</SelectItem>
                                            ))}
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="h-px bg-gray-200/60 dark:bg-[#383838]" />

            {/* Mensagens */}
            {mensagemIntervalo !== undefined && (
                <>
                    <div>
                        <h4 className="text-sm font-semibold text-gray-900 dark:text-[#D1D2D3] mb-3">Mensagens</h4>
                        <RowInput
                            label={"Mensagem de intervalo"}
                            input={<Textarea
                                onChange={e => {
                                    changeMensagemIntervalo && changeMensagemIntervalo(e);
                                    changeIsModificado && changeIsModificado(true);
                                }}
                                value={mensagemIntervalo}
                                className="border-gray-200 dark:border-[#383838] dark:bg-[#1A1D21] dark:text-[#D1D2D3] focus:border-[#7C3AED]/50 focus:ring-[#7C3AED]/20 rounded-lg"
                                rows={3}
                            />}
                        />
                    </div>
                    <div className="h-px bg-gray-200/60 dark:bg-[#383838]" />
                </>
            )}

            {/* Sistema */}
            {user && (
                <>
                    <div>
                        <h4 className="text-sm font-semibold text-gray-900 dark:text-[#D1D2D3] mb-3">Sistema</h4>
                        <div className="flex flex-col sm:flex-row gap-3">
                            <Button
                                onClick={() => {
                                    deleteAllCacheFiles();
                                    enqueueSnackbar('Arquivos armazenados foram deletados', { variant: 'success' });
                                }}
                                className="bg-red-50 dark:bg-red-500/10 text-red-700 dark:text-red-400 border border-red-200 dark:border-red-500/20 hover:bg-red-100 dark:hover:bg-red-500/20 rounded-lg text-xs font-medium transition-colors"
                            >
                                <Iconify icon="fluent:delete-20-regular" className="mr-2" width={16} />
                                Limpar arquivos em cache
                            </Button>

                            {cliente && (
                                <ButtonLoading
                                    className="bg-red-50 dark:bg-red-500/10 text-red-700 dark:text-red-400 border border-red-200 dark:border-red-500/20 hover:bg-red-100 dark:hover:bg-red-500/20 rounded-lg text-xs font-medium transition-colors"
                                    onClick={limparChats}
                                    loading={loadingLimparChats}
                                >
                                    <Iconify icon="fluent:delete-20-regular" className="mr-2" width={16} />
                                    Limpar chats "No Bot"
                                </ButtonLoading>
                            )}
                        </div>
                    </div>
                    <div className="h-px bg-gray-200/60 dark:bg-[#383838]" />
                </>
            )}

            {/* Preferencias de Interface */}
            <div>
                <h4 className="text-sm font-semibold text-gray-900 dark:text-[#D1D2D3] mb-1">Preferências de Interface</h4>
                <p className="text-xs text-gray-500 dark:text-[#ABABAD] mb-4">
                    Escolha como deseja visualizar o menu de navegação
                </p>

                <div className="flex flex-col sm:flex-row gap-4">
                    {/* Navbar */}
                    <button
                        onClick={() => handleLayoutChange('navbar')}
                        className={`flex-1 p-4 rounded-xl border-2 transition-all duration-200 text-left ${
                            layoutMode === 'navbar'
                                ? 'border-[#7C3AED] bg-[#7C3AED]/5 dark:bg-[#7C3AED]/10'
                                : 'border-gray-200 dark:border-[#383838] hover:border-gray-300 dark:hover:border-[#565856] bg-white dark:bg-[#1A1D21]'
                        }`}
                    >
                        <div className="flex items-start gap-3">
                            <div className={`p-2 rounded-lg ${
                                layoutMode === 'navbar'
                                    ? 'bg-[#7C3AED]/10 text-[#7C3AED]'
                                    : 'bg-gray-100 dark:bg-[#383838] text-gray-500 dark:text-[#ABABAD]'
                            }`}>
                                <Iconify icon="solar:hamburger-menu-linear" width={24} />
                            </div>
                            <div className="flex-1">
                                <div className="flex items-center gap-2">
                                    <span className="text-sm font-semibold text-gray-900 dark:text-[#D1D2D3]">Barra Superior</span>
                                    {layoutMode === 'navbar' && (
                                        <span className="text-[10px] px-2 py-0.5 rounded-full bg-[#7C3AED] text-white font-medium">
                                            Ativo
                                        </span>
                                    )}
                                </div>
                                <span className="text-xs text-gray-500 dark:text-[#ABABAD] block mt-0.5">
                                    Menu horizontal no topo da tela. Layout tradicional e compacto.
                                </span>
                            </div>
                        </div>
                        <div className="mt-3 p-2 bg-gray-50 dark:bg-[#1A1D21] rounded-lg">
                            <div className="h-2 bg-[#7C3AED]/20 rounded mb-1"></div>
                            <div className="flex gap-1">
                                <div className="flex-1 h-8 bg-gray-200 dark:bg-[#383838] rounded"></div>
                            </div>
                        </div>
                    </button>

                    {/* Sidebar */}
                    <button
                        onClick={() => handleLayoutChange('sidebar')}
                        className={`flex-1 p-4 rounded-xl border-2 transition-all duration-200 text-left ${
                            layoutMode === 'sidebar'
                                ? 'border-[#7C3AED] bg-[#7C3AED]/5 dark:bg-[#7C3AED]/10'
                                : 'border-gray-200 dark:border-[#383838] hover:border-gray-300 dark:hover:border-[#565856] bg-white dark:bg-[#1A1D21]'
                        }`}
                    >
                        <div className="flex items-start gap-3">
                            <div className={`p-2 rounded-lg ${
                                layoutMode === 'sidebar'
                                    ? 'bg-[#7C3AED]/10 text-[#7C3AED]'
                                    : 'bg-gray-100 dark:bg-[#383838] text-gray-500 dark:text-[#ABABAD]'
                            }`}>
                                <Iconify icon="solar:sidebar-minimalistic-linear" width={24} />
                            </div>
                            <div className="flex-1">
                                <div className="flex items-center gap-2">
                                    <span className="text-sm font-semibold text-gray-900 dark:text-[#D1D2D3]">Barra Lateral</span>
                                    {layoutMode === 'sidebar' && (
                                        <span className="text-[10px] px-2 py-0.5 rounded-full bg-[#7C3AED] text-white font-medium">
                                            Ativo
                                        </span>
                                    )}
                                </div>
                                <span className="text-xs text-gray-500 dark:text-[#ABABAD] block mt-0.5">
                                    Menu vertical na lateral esquerda. Mais espaço para navegação.
                                </span>
                            </div>
                        </div>
                        <div className="mt-3 p-2 bg-gray-50 dark:bg-[#1A1D21] rounded-lg">
                            <div className="flex gap-1">
                                <div className="w-4 h-8 bg-[#7C3AED]/20 rounded"></div>
                                <div className="flex-1 h-8 bg-gray-200 dark:bg-[#383838] rounded"></div>
                            </div>
                        </div>
                    </button>
                </div>
            </div>

            <div className="h-px bg-gray-200/60 dark:bg-[#383838]" />

            {/* Aparencia */}
            <div>
                <h4 className="text-sm font-semibold text-gray-900 dark:text-[#D1D2D3] mb-1">Aparência</h4>
                <p className="text-xs text-gray-500 dark:text-[#ABABAD] mb-4">
                    Escolha o tema de cores da interface
                </p>

                <div className="flex flex-col sm:flex-row gap-4">
                    {/* Light */}
                    <button
                        onClick={() => handleThemeChange('light')}
                        className={`flex-1 p-4 rounded-xl border-2 transition-all duration-200 text-left ${
                            themeMode === 'light'
                                ? 'border-[#7C3AED] bg-[#7C3AED]/5 dark:bg-[#7C3AED]/10'
                                : 'border-gray-200 dark:border-[#383838] hover:border-gray-300 dark:hover:border-[#565856] bg-white dark:bg-[#1A1D21]'
                        }`}
                    >
                        <div className="flex items-start gap-3">
                            <div className={`p-2 rounded-lg ${
                                themeMode === 'light'
                                    ? 'bg-[#7C3AED]/10 text-[#7C3AED]'
                                    : 'bg-gray-100 dark:bg-[#383838] text-gray-500 dark:text-[#ABABAD]'
                            }`}>
                                <Iconify icon="solar:sun-bold-duotone" width={24} />
                            </div>
                            <div className="flex-1">
                                <div className="flex items-center gap-2">
                                    <span className="text-sm font-semibold text-gray-900 dark:text-[#D1D2D3]">Modo Claro</span>
                                    {themeMode === 'light' && (
                                        <span className="text-[10px] px-2 py-0.5 rounded-full bg-[#7C3AED] text-white font-medium">
                                            Ativo
                                        </span>
                                    )}
                                </div>
                                <span className="text-xs text-gray-500 dark:text-[#ABABAD] block mt-0.5">
                                    Interface com fundo claro e cores vibrantes.
                                </span>
                            </div>
                        </div>
                        <div className="mt-3 p-2 bg-white dark:bg-[#1A1D21] border border-gray-200 dark:border-[#383838] rounded-lg">
                            <div className="flex gap-1">
                                <div className="w-3 h-3 rounded-full bg-red-400"></div>
                                <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                                <div className="w-3 h-3 rounded-full bg-green-400"></div>
                            </div>
                            <div className="mt-2 h-2 bg-gray-200 dark:bg-[#383838] rounded w-3/4"></div>
                            <div className="mt-1 h-2 bg-gray-100 dark:bg-[#2a2d31] rounded w-1/2"></div>
                        </div>
                    </button>

                    {/* Dark */}
                    {/* <button
                        onClick={() => handleThemeChange('dark')}
                        className={`flex-1 p-4 rounded-xl border-2 transition-all duration-200 text-left ${
                            themeMode === 'dark'
                                ? 'border-[#7C3AED] bg-[#7C3AED]/5 dark:bg-[#7C3AED]/10'
                                : 'border-gray-200 dark:border-[#383838] hover:border-gray-300 dark:hover:border-[#565856] bg-white dark:bg-[#1A1D21]'
                        }`}
                    >
                        <div className="flex items-start gap-3">
                            <div className={`p-2 rounded-lg ${
                                themeMode === 'dark'
                                    ? 'bg-[#7C3AED]/10 text-[#7C3AED]'
                                    : 'bg-gray-100 dark:bg-[#383838] text-gray-500 dark:text-[#ABABAD]'
                            }`}>
                                <Iconify icon="solar:moon-bold-duotone" width={24} />
                            </div>
                            <div className="flex-1">
                                <div className="flex items-center gap-2">
                                    <span className="text-sm font-semibold text-gray-900 dark:text-[#D1D2D3]">Modo Escuro</span>
                                    {themeMode === 'dark' && (
                                        <span className="text-[10px] px-2 py-0.5 rounded-full bg-[#7C3AED] text-white font-medium">
                                            Ativo
                                        </span>
                                    )}
                                </div>
                                <span className="text-xs text-gray-500 dark:text-[#ABABAD] block mt-0.5">
                                    Interface com fundo escuro, ideal para ambientes com pouca luz.
                                </span>
                            </div>
                        </div>
                        <div className="mt-3 p-2 bg-gray-900 border border-gray-700 rounded-lg">
                            <div className="flex gap-1">
                                <div className="w-3 h-3 rounded-full bg-red-400"></div>
                                <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                                <div className="w-3 h-3 rounded-full bg-green-400"></div>
                            </div>
                            <div className="mt-2 h-2 bg-gray-700 rounded w-3/4"></div>
                            <div className="mt-1 h-2 bg-gray-800 rounded w-1/2"></div>
                        </div>
                    </button> */}
                </div>
            </div>

            {isModificado && (
                <div className="pt-4">
                    <ButtonLoading
                        onClick={onSubmit}
                        className="h-9 gap-2 bg-[#7C3AED] hover:bg-[#6D28D9] text-white text-xs font-semibold rounded-lg shadow-lg shadow-violet-500/20 transition-all hover:scale-105 active:scale-95"
                    >
                        Salvar
                    </ButtonLoading>
                </div>
            )}
        </div>
    );
}
